
export class NotificationConfig {
    email:string;
    panicIsSystem: boolean;
    panicIsEmail: boolean;
    stoppedOnIsSystem: boolean;
    stoppedOnIsEmail: boolean;
    stoppedOnConfig: string;
    stoppedOffIsSystem: boolean;
    stoppedOffIsEmail: boolean;
    stoppedOffConfig: string;
    noSignalIsSystem: boolean;
    noSignalIsEmail: boolean;
    noSignalConfig: string;
    cnhOutdatedIsSystem: boolean;
    cnhOutdatedIsEmail: boolean;
    cnhOutdatedConfig: string;
    maxVelocityIsSystem: boolean;
    maxVelocityIsEmail: boolean;
    outOfRouteIsSystem: boolean;
    outOfRouteIsEmail: boolean;

    constructor (  email:string,
                    panicIsSystem: boolean,
                    panicIsEmail: boolean,
                    stoppedOnIsSystem: boolean,
                    stoppedOnIsEmail: boolean,
                    stoppedOnConfig: string,
                    stoppedOffIsSystem: boolean,
                    stoppedOffIsEmail: boolean,
                    stoppedOffConfig: string,
                    noSignalIsSystem: boolean,
                    noSignalIsEmail: boolean,
                    noSignalConfig: string,
                    cnhOutdatedIsSystem: boolean,
                    cnhOutdatedIsEmail: boolean,
                    cnhOutdatedConfig: string,
                    maxVelocityIsSystem: boolean,
                    maxVelocityIsEmail: boolean,
                    outOfRouteIsSystem: boolean,
                    outOfRouteIsEmail: boolean) {
        this.email = email;
        this.panicIsSystem = panicIsSystem;
        this.panicIsEmail = panicIsEmail;
        this.stoppedOnIsSystem = stoppedOnIsSystem;
        this.stoppedOnIsEmail = stoppedOnIsEmail;
        this.stoppedOnConfig = stoppedOnConfig;
        this.stoppedOffIsSystem = stoppedOffIsSystem;
        this.stoppedOffIsEmail = stoppedOffIsEmail;
        this.stoppedOffConfig = stoppedOffConfig;
        this.noSignalIsSystem = noSignalIsSystem;
        this.noSignalIsEmail = noSignalIsEmail;
        this.noSignalConfig = noSignalConfig;
        this.cnhOutdatedIsSystem = cnhOutdatedIsSystem;
        this.cnhOutdatedIsEmail = cnhOutdatedIsEmail;
        this.cnhOutdatedConfig = cnhOutdatedConfig;
        this.maxVelocityIsSystem = maxVelocityIsSystem;
        this.maxVelocityIsEmail = maxVelocityIsEmail;
        this.outOfRouteIsSystem = outOfRouteIsSystem;
        this.outOfRouteIsEmail = outOfRouteIsEmail;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/notification-config.ts